import { Map as map } from 'immutable';
const C = require("../constants");

function OtherSaleSelectReducer(state = map(), action) {
    switch (action.type) {
        case C.OTHER_SALE_SELECT:
            return action.data;
        default:
            return state;
    }
};

export default OtherSaleSelectReducer;


// WEBPACK FOOTER //
// ./src/reducers/OtherSaleSelectReducer.js